export const TIMEZONE = '/timezones';
export const FETCH_TIMEZONE = `${TIMEZONE}/search`;
